import { Link } from "react-router-dom";

const heroImage = "/Images/AboutHero.png";

const About = () => {
  return (
    <>
      {/* ── HERO ── */}
      <section
        style={{
          height: "520px",
          position: "relative",
          backgroundImage: `url(${heroImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div
          style={{
            position: "absolute",
            inset: 0,
            background: "linear-gradient(to bottom, rgba(0,0,0,.15), rgba(0,0,0,.65))",
          }}
        />

        <div
          style={{
            maxWidth: "1100px",
            margin: "0 auto",
            padding: "0 24px",
            height: "100%",
            position: "relative",
            display: "flex",
            alignItems: "flex-end",
            paddingBottom: "48px",
          }}
        >
          <div style={{ maxWidth: "480px", color: "#fff" }}>
            <div
              style={{
                fontFamily: "'Helvetica Neue', Arial, sans-serif",
                fontSize: "10px",
                fontWeight: 600,
                letterSpacing: "2px",
                textTransform: "uppercase",
                marginBottom: "10px",
                color: "rgba(255,255,255,.75)",
              }}
            >
              Our Mission
            </div>

            <h1
              style={{
                fontFamily: "Georgia, 'Times New Roman', serif",
                fontSize: "48px",
                fontWeight: 400,
                lineHeight: 1.05,
                margin: "0 0 16px 0",
              }}
            >
              A teenager in Colorado, Saves
              <br />
              Birds in Africa.
            </h1>

            <p
              style={{
                fontFamily: "'Helvetica Neue', Arial, sans-serif",
                fontSize: "14px",
                lineHeight: 1.8,
                color: "rgba(255,255,255,.85)",
                margin: 0,
                maxWidth: "440px",
              }}
            >
              Connecting passionate conservationists across continents to protect the
              world's most vulnerable avian species through technology and advocacy.
            </p>
          </div>
        </div>
      </section>

      {/* ── STORY ── */}
      <section style={{ background: "#f5f3ee", padding: "64px 0" }}>
        <div style={{ maxWidth: "900px", margin: "0 auto", padding: "0 24px" }}>

          <h3
            style={{
              fontFamily: "Georgia, 'Times New Roman', serif",
              fontSize: "26px",
              fontWeight: 400,
              margin: "0 0 24px 0",
            }}
          >
            My Story
          </h3>

          <p
            style={{
              fontFamily: "'Helvetica Neue', Arial, sans-serif",
              fontSize: "14px",
              lineHeight: 2,
              color: "#666",
              margin: "0 0 20px 0",
            }}
          >
            It all started with a single pair of binoculars and a deep sense of curiosity. Growing up in the shadow of the Rockies, I came to understand that conservation is about more than just protecting local parks, it’s part of a much larger global ecosystem.
          </p>

          <p
            style={{
              fontFamily: "'Helvetica Neue', Arial, sans-serif",
              fontSize: "14px",
              lineHeight: 2,
              color: "#666",
              margin: 0,
            }}
          >
            Through international advocacy, I help turn individual passion into collective action by raising awareness about endangered species and directing support and funding to the places where it’s needed most.
          </p>

          {/* <div
            style={{
              marginTop: "40px",
              paddingLeft: "24px",
              borderLeft: "3px solid #c98d2c",
            }}
          >
            <p
              style={{
                fontFamily: "Georgia, 'Times New Roman', serif",
                fontStyle: "italic",
                fontSize: "22px",
                lineHeight: 1.6,
                margin: 0,
                color: "#333",
              }}
            >
              "The distance between a mountain in Colorado and a wetlands in Africa is only as vast as our unwillingness to connect the two."
            </p>
          </div> */}

        </div>
      </section>

      {/* ── WHAT I ACTUALLY DO ── */}
      <section style={{ background: "#6d735d", padding: "72px 0" }}>
        <div style={{ maxWidth: "1100px", margin: "0 auto", padding: "0 24px" }}>
          <div style={{ display: "flex", gap: "80px", alignItems: "flex-start" }}>

            {/* LEFT */}
            <div style={{ flex: "0 0 340px" }}>
              <h2
                style={{
                  fontFamily: "Georgia, 'Times New Roman', serif",
                  fontSize: "32px",
                  fontWeight: 400,
                  color: "#fff",
                  margin: "0 0 20px 0",
                }}
              >
                What I Actually Do
              </h2>

              {/* <p
                style={{
                  fontFamily: "'Helvetica Neue', Arial, sans-serif",
                  fontSize: "13.5px",
                  lineHeight: 1.85,
                  color: "rgba(255,255,255,.8)",
                  margin: "0 0 32px 0",
                }}
              >
                Beyond the storytelling, WildGuard is a machine of rigorous data
                and strategic action. We operate at the intersection of field
                biology and international policy.
              </p> */}

              {/* list items with icons */}
              {[
                {
                  icon: (
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,.7)" strokeWidth="1.5">
                      <circle cx="11" cy="11" r="8" /><path d="M21 21l-4.35-4.35" />
                      <path d="M11 8v6M8 11h6" />
                    </svg>
                  ),
                  title: "Scientific Research:",
                  text: "Conducting Studies on endangered birds.",
                },
                {
                  icon: (
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,.7)" strokeWidth="1.5">
                      <path d="M3 12h18M3 6h18M3 18h12" />
                    </svg>
                  ),
                  title: "Global Advocacy:",
                  text: "Lobbying for international treaties that protect vital habitats.",
                },
                {
                  icon: (
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,.7)" strokeWidth="1.5">
                      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                    </svg>
                  ),
                  title: "Transparency:",
                  text: "Maintaining strict non-profit compliance and fiscal integrity.",
                },
              ].map((item, i) => (
                <div
                  key={i}
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "14px",
                    marginBottom: "20px",
                  }}
                >
                  <div style={{ flexShrink: 0, marginTop: "2px" }}>{item.icon}</div>
                  <p
                    style={{
                      fontFamily: "'Helvetica Neue', Arial, sans-serif",
                      fontSize: "13px",
                      lineHeight: 1.7,
                      color: "rgba(255,255,255,.85)",
                      margin: 0,
                    }}
                  >
                    <strong style={{ fontWeight: 600 }}>{item.title}</strong>{" "}
                    {item.text}
                  </p>
                </div>
              ))}
            </div>

            {/* RIGHT — partner cards */}
            <div style={{ flex: 1 }}>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px" }}>

                {/* Birdlife Partner */}
                {/* <div
                  style={{
                    background: "rgba(255,255,255,.1)",
                    padding: "40px 24px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "14px",
                  }}
                >
                  <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,.85)" strokeWidth="1.4">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z"/>
                    <path d="M8 12c0-2.21 1.79-4 4-4s4 1.79 4 4-1.79 4-4 4-4-1.79-4-4z"/>
                    <path d="M12 8V4M12 20v-4M4 12H2M22 12h-2"/>
                  </svg>
                  <div style={{ textAlign: "center" }}>
                    <div
                      style={{
                        fontFamily: "'Helvetica Neue', Arial, sans-serif",
                        fontSize: "10px",
                        fontWeight: 700,
                        letterSpacing: "2px",
                        color: "rgba(255,255,255,.9)",
                        textTransform: "uppercase",
                      }}
                    >
                      Birdlife Partner
                    </div>
                  </div>
                </div> */}

                {/* IUCN */}
                {/* <div
                  style={{
                    background: "rgba(255,255,255,.1)",
                    padding: "40px 24px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "14px",
                  }}
                >
                  <div
                    style={{
                      fontFamily: "Georgia, 'Times New Roman', serif",
                      fontSize: "32px",
                      fontWeight: 700,
                      color: "rgba(255,255,255,.9)",
                      letterSpacing: "2px",
                    }}
                  >
                    IUCN
                  </div>
                  <div
                    style={{
                      fontFamily: "'Helvetica Neue', Arial, sans-serif",
                      fontSize: "10px",
                      fontWeight: 700,
                      letterSpacing: "2px",
                      color: "rgba(255,255,255,.6)",
                      textTransform: "uppercase",
                    }}
                  >
                    SSC Member
                  </div>
                </div> */}

                {/* Species Data Table — spans both columns */}
                <div
                  style={{
                    gridColumn: "1 / -1",
                    background: "rgba(255,255,255,.05)",
                    padding: "24px",
                    borderRadius: "8px",
                  }}
                >
                  <div
                    style={{
                      fontFamily: "Georgia, 'Times New Roman', serif",
                      fontSize: "20px",
                      color: "#fff",
                      margin: "0 0 16px 0",
                      textAlign: "center"
                    }}
                  >
                    Conservation Data Overview
                  </div>
                  <table
                    style={{
                      width: "100%",
                      borderCollapse: "collapse",
                      fontFamily: "'Helvetica Neue', Arial, sans-serif",
                      fontSize: "13px",
                      color: "rgba(255,255,255,.85)",
                    }}
                  >
                    <thead>
                      <tr style={{ borderBottom: "1px solid rgba(255,255,255,.2)", textAlign: "left" }}>
                        <th style={{ padding: "10px", fontWeight: 600 }}>Species</th>
                        <th style={{ padding: "10px", fontWeight: 600 }}>Est. Population</th>
                        <th style={{ padding: "10px", fontWeight: 600 }}>Active Trackers</th>
                        <th style={{ padding: "10px", fontWeight: 600 }}>Habitats Protected</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr style={{ borderBottom: "1px solid rgba(255,255,255,.1)" }}>
                        <td style={{ padding: "10px" }}>Southern Ground Hornbill</td>
                        <td style={{ padding: "10px" }}>~1,500</td>
                        <td style={{ padding: "10px" }}>42</td>
                        <td style={{ padding: "10px" }}>8</td>
                      </tr>
                      <tr style={{ borderBottom: "1px solid rgba(255,255,255,.1)" }}>
                        <td style={{ padding: "10px" }}>Pel's Fishing Owl</td>
                        <td style={{ padding: "10px" }}>~250 Pairs</td>
                        <td style={{ padding: "10px" }}>14</td>
                        <td style={{ padding: "10px" }}>3</td>
                      </tr>
                      <tr style={{ borderBottom: "1px solid rgba(255,255,255,.1)" }}>
                        <td style={{ padding: "10px" }}>African Penguin</td>
                        <td style={{ padding: "10px" }}>~41,700</td>
                        <td style={{ padding: "10px" }}>105</td>
                        <td style={{ padding: "10px" }}>12</td>
                      </tr>
                      <tr style={{ borderBottom: "1px solid rgba(255,255,255,.1)" }}>
                        <td style={{ padding: "10px" }}>Cape Gannet</td>
                        <td style={{ padding: "10px" }}>~246,000</td>
                        <td style={{ padding: "10px" }}>78</td>
                        <td style={{ padding: "10px" }}>5</td>
                      </tr>
                      <tr style={{ borderBottom: "1px solid rgba(255,255,255,.1)" }}>
                        <td style={{ padding: "10px" }}>Bearded Vulture</td>
                        <td style={{ padding: "10px" }}>~320 (Regional)</td>
                        <td style={{ padding: "10px" }}>26</td>
                        <td style={{ padding: "10px" }}>4</td>
                      </tr>
                      <tr>
                        <td style={{ padding: "10px" }}>Saddle-billed Stork</td>
                        <td style={{ padding: "10px" }}>~1,000</td>
                        <td style={{ padding: "10px" }}>19</td>
                        <td style={{ padding: "10px" }}>6</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

              </div>
            </div>

          </div>
        </div>
      </section>

      {/* ── CTA ── */}
      <section style={{ background: "#f5f3ee", padding: "64px 0" }}>
        <div
          style={{
            maxWidth: "900px",
            margin: "0 auto",
            padding: "0 24px",
            textAlign: "center",
          }}
        >
          <hr style={{ marginBottom: "48px", borderColor: "#ddd" }} />

          <h2
            style={{
              fontFamily: "Georgia, 'Times New Roman', serif",
              fontSize: "32px",
              fontWeight: 400,
              margin: "0 0 16px 0",
            }}
          >
            Be the link in the chain.
          </h2>

          <p
            style={{
              fontFamily: "'Helvetica Neue', Arial, sans-serif",
              fontSize: "14px",
              color: "#666",
              margin: "0 0 28px 0",
              lineHeight: 1.7,
            }}
          >
            Your support funds research, protects habitats, and empowers advocates globally.
          </p>

          <Link to="/donate" style={{ textDecoration: "none" }}>
            <button
              style={{
                background: "#9b5d08",
                color: "#fff",
                border: "none",
                padding: "12px 28px",
                fontSize: "11px",
                fontFamily: "'Helvetica Neue', Arial, sans-serif",
                fontWeight: 700,
                letterSpacing: "1.5px",
                cursor: "pointer",
              }}
            >
              SUPPORT THIS WORK →
            </button>
          </Link>
        </div>
      </section>
    </>
  );
};

export default About;